import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import HandleFormData from '~/utils/HandleFormData';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
import ColoredFileInput from '~/componentes/CustomForm/FileInput/styles/ColoredFileInput';

import { Container } from './styles';
import { Materialize } from '~/styles/materializeGrid';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import RecursosList from './RecursosList';
import PrioridadeListColor from './PrioridadeListColor';
import AtividadesList from './AtividadesList';
import AcessosList from './AcessosList';
import StatusDataList from './StatusDataList';

function CreateEditContent({ mountedData }) {
  const [abaAtiva, setAbaAtiva] = useState(0);
  const abas = [
    { titulo: 'Projeto' },
    { titulo: 'Horas' },
    { titulo: 'Atividades' },
    { titulo: 'Configurações' },
    { titulo: 'Acessos' },
  ];

  const [etapas, setEtapas] = useState([]);
  const [contratos, setContratos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(mountedData ? mountedData?.cliente : {});
  const [solicitantes, setSolicitantes] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [recursos, setRecursos] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [statusDatas, setStatusDatas] = useState([]);
  const [acessos, setAcessos] = useState([]);
  const [prioridade, setPrioridade] = useState({});
  const [idEtapa, setIdEtapa] = useState(mountedData ? mountedData?.idEtapaFluxo : 1);
  const [horaTotal, setHoraTotal] = useState(mountedData ? mountedData?.horaTotal : 0);
  const [horaSaldo, setHoraSaldo] = useState(mountedData ? mountedData?.horaSaldo : 0);
  const [horaUsada, setHoraUsada] = useState(mountedData ? mountedData?.horaUsada : 0);
  const [dataInicioProjeto, setDataInicioProjeto] = useState(
    mountedData ? mountedData?.previsaoInicio : new Date(),
  );
  const [gerarProjeto, setGerarProjeto] = useState(false);
  const [removeArquivos, setRemoveArquivos] = React.useState([]);
  const [file1, setFile1] = useState();
  const [file2, setFile2] = useState();
  const [file3, setFile3] = useState();
  const [file4, setFile4] = useState();
  const [ativo, setAtivo] = useState(!mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false');
  const [valorHoraBruto, setValorHoraBruto] = useState(mountedData ? mountedData?.valorHora : 0);
  const [valorHoraLiquido, setValorHoraLiquido] = useState(
    mountedData ? mountedData?.valorHoraLiquido : 0,
  );
  const [horaLevantamento, setHoraLevantamento] = useState(
    mountedData ? mountedData?.horaLevantamento : 0,
  );
  const [valorTotalBruto, setValorTotalBruto] = useState(mountedData ? mountedData?.valorTotal : 0);
  const [valorTotalLiquido, setValorTotalLiquido] = useState(
    mountedData ? mountedData?.valorTotalLiquido : 0,
  );
  const [margemLucro, setMargemLucro] = useState(mountedData ? mountedData?.margemLucro : 0);
  const [valorOrcamento, setValorOrcamento] = useState(
    mountedData ? mountedData?.valorOrcamento : 0,
  );
  const [horasPrevistaDev, setHorasPrevistaDev] = useState(
    mountedData ? mountedData?.horasPrevistaDev : 0,
  );
  const [valorMediaAna, setValorMediaAna] = useState(mountedData ? mountedData?.valorMediaAna : 0);
  const [valorImposto, setValorImposto] = useState(mountedData ? mountedData?.valorImposto : 0);
  const [percentualImposto, setPercentualImposto] = useState(
    mountedData ? mountedData?.percentualImposto : 0,
  );
  const [percentualLucro, setPercentualLucro] = useState(
    mountedData ? mountedData?.percentualLucro : 0,
  );
  const [percentualGP, setPercentualGP] = useState(mountedData ? mountedData?.percentualGP : 0);
  const [horasGP, setHorasGP] = useState(mountedData ? mountedData?.horasGP : 0);
  const [horasDev, setHorasDev] = useState(mountedData ? mountedData?.horasDev : 0);

  useEffect(() => {
    if (mountedData) {
      setHoraTotal(mountedData?.horaTotal);
      setHoraSaldo(mountedData?.horaSaldo);
      api
        .get('/signed/empresa/gestorprojeto/etapa/etapas', { params: { ativo: 1, tipo: 'FPJ' } })
        .then(r => {
          setEtapas(r?.data);
          setIdEtapa(mountedData?.idEtapaFluxo);
        });
    } else {
      api
        .get('/signed/empresa/gestorprojeto/etapa/etapas', {
          params: { ativo: 1, tipo: 'FPJ', posicao: 1 },
        })
        .then(r => {
          setEtapas(r?.data);
          if (r?.data?.length > 0) {
            setIdEtapa(r?.data[0]?.id);
          }
        });
    }

    api
      .get('/signed/empresa/suporte/contratos', { params: { ativo: 1, listContrato: true } })
      .then(r => setContratos(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/cliente/clientes', { params: { ativo: 1 } })
      .then(r => setClientes(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/gerencia/coordenadores', { params: { ativo: 1 } })
      .then(r => setCoordenadores(r?.data));
    api
      .get('/signed/empresa/gestorprojeto/gerencia/produtos', { params: { ativo: 1 } })
      .then(r => setProdutos(r?.data));
  }, []);

  useEffect(() => {
    if (cliente?.id) {
      cliente?.id &&
        api
          .get('/signed/empresa/gestorprojeto/gerencia/clientesolicitantes', {
            params: { ativo: 1, idCliente: cliente?.id },
          })
          .then(r => setSolicitantes(r?.data));
    } else {
      setSolicitantes([]);
    }
  }, [cliente]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = HandleFormData([file1, file2, file3, file4], {
          emailRespCliente: data?.emailRespCliente,
          horaTotal: data?.horaTotal,
          valorTotal: valorTotalBruto,
          valorHoraLiquido,
          horaLevantamento,
          valorHora: valorHoraBruto,
          valorTotalLiquido,
          margemLucro,
          valorOrcamento,
          horasPrevistaDev,
          valorMediaAna,
          valorImposto,
          percentualImposto,
          percentualLucro,
          percentualGP,
          horasGP,
          horasDev,
          dataInicioProjeto: data?.dataInicioProjeto,
          dataPrevEntregaProjeto: data?.dataPrevEntregaProjeto,
          descricaoProjeto: data?.descricaoProjeto,
          idCoordenador: data?.idCoordenador,
          idCoordenadorTec: data?.idCoordenadorTec,
          idClienteSolicitante: data?.idClienteSolicitante,
          tipoProjeto: data?.tipoProjeto,
          anotacao: data?.anotacao,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
          gerarProjeto,
          recursos,
          idEtapaFluxo: idEtapa,
          etapas: statusDatas,
          horaTotal,
          prioridade,
          atividades,
          acessos,
          removeArquivos,
        });

        let response;
        if (mountedData?.id)
          response = await api.put('/signed/empresa/gestorprojeto/fluxoprojeto', thisData);
        else response = await api.post('/signed/empresa/gestorprojeto/fluxoprojeto', thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            mountedData?.id ? 'atualizar' : 'cadastrar'
          } esse Projeto, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${
          mountedData?.id ? 'atualizar' : 'cadastrar'
        } esse Projeto?`,
        successModal: `Projeto ${mountedData?.id ? 'atualizado' : 'cadastrado'} com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true} noValidate>
      <Materialize className="materialize">
        <div className="row header">
          {abas.map((thisVal, a) => (
            <div
              key={thisVal?.titulo}
              className={abaAtiva == a ? 'item-aba ativo' : 'item-aba'}
              onClick={() => setAbaAtiva(a)}
            >
              <span></span>
              <p>{thisVal?.titulo}</p>
            </div>
          ))}
        </div>
        {mountedData && (
          <div>
            <div className={abaAtiva == 0 ? 'item-modal ativo' : ' item-modal'}>
              <div className="row no-margin">
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Cliente *" className="col s12 m4 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: clientes, value: 'id', label: 'nomeFantasia' }}
                        name="idCliente"
                        disabled="true"
                        firstOption
                        defaultValue={mountedData?.idCliente}
                        onChange={e => {
                          const v = e.currentTarget.value || 'true';
                          const cliente = clientes?.find(e => e?.id == parseInt(v));
                          setCliente(cliente || {});
                        }}
                      />
                    </Label>
                    <Label title="Aprovador 1 *" className="col s12 m6 l4">
                      <Select
                        required="true"
                        isString
                        list={{ list: coordenadores, value: 'id', label: 'nome' }}
                        name="idCoordenador"
                        firstOption
                        defaultValue={mountedData?.idCoordenador}
                      />
                    </Label>
                    <Label title="Aprovador 2" className="col s12 m6 l4">
                      <Select
                        isString
                        list={{ list: coordenadores, value: 'id', label: 'nome' }}
                        name="idCoordenadorTec"
                        firstOption
                        defaultValue={mountedData?.idCoordenadorTec}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Data Solicitação *" className="col s12 m6 l3">
                      <Input
                        type="date"
                        disabled="true"
                        name="dataProjeto"
                        required="true"
                        defaultValue={mountedData?.dataProjeto}
                      />
                    </Label>
                    <Label title="Data Inicio *" className="col s12 m6 l3">
                      <Input
                        type="date"
                        name="dataInicioProjeto"
                        required="true"
                        defaultValue={dataInicioProjeto}
                        onBlur={e => {
                          const v = e.currentTarget.value || '';
                          setDataInicioProjeto(v);
                        }}
                      />
                    </Label>
                    <Label title="Data Prev Entrega *" className="col s12 m6 l3">
                      <Input
                        type="date"
                        name="dataPrevEntregaProjeto"
                        required="true"
                        defaultValue={mountedData?.previsaoEntrega}
                      />
                    </Label>
                    <Label title="Tipo Projeto *" className="col s12 m6 l3">
                      <Select
                        required="true"
                        isString
                        list={{
                          list: [
                            { id: 'S', titulo: 'Suporte' },
                            { id: 'B', titulo: 'Banco de Horas' },
                            { id: 'P', titulo: 'Projeto' },
                            { id: 'A', titulo: 'Avulso' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name="tipoProjeto"
                        firstOption
                        defaultValue={mountedData?.tipoProjeto}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Descrição do Projeto" className="col s12 m12 l12">
                      <TextArea
                        name="descricaoProjeto"
                        defaultValue={mountedData?.descricaoProjeto}
                      />
                    </Label>
                  </div>
                </div>
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Anotações do Projeto" className="col s12 m12 l12">
                      <TextArea
                        name="anotacao"
                        className="fullText"
                        defaultValue={mountedData?.anotacao}
                      />
                    </Label>
                  </div>
                </div>
              </div>
              <div className="row no-margin">
                <Label title="Anexo 1" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo1"
                    defaultFile={mountedData?.anexo1}
                    formFile={setFile1}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 2" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo2"
                    defaultFile={mountedData?.anexo2}
                    formFile={setFile2}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 3" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo3"
                    defaultFile={mountedData?.anexo3}
                    formFile={setFile3}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
                <Label title="Anexo 4" className="col s12 m6 l3">
                  <ColoredFileInput
                    name="anexo4"
                    defaultFile={mountedData?.anexo4}
                    formFile={setFile4}
                    onDefaultFileRemove={e => e?.id && setRemoveArquivos(prev => [...prev, e?.id])}
                  />
                </Label>
              </div>
            </div>
            <div className={abaAtiva == 1 ? 'item-modal ativo' : ' item-modal'}>
              <div className="row no-margin">
                <div className="col s12 m12 l8 no-padding">
                  <div className="row no-margin">
                    <Label title="Hora Levantamento *" className="col s12 m6 l3">
                      <Input
                        type="number"
                        name="horaLevantamento"
                        required="true"
                        min="1"
                        value={horaLevantamento}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setHoraLevantamento(v);
                          setValorTotalBruto(valorHoraBruto * v);
                          setValorHoraLiquido(
                            valorHoraBruto - valorHoraBruto * (percentualImposto / 100),
                          );

                          let valorHTLiquido = parseFloat(
                            (
                              (valorHoraBruto - valorHoraBruto * (percentualImposto / 100)) *
                              v
                            ).toFixed(2),
                          );
                          setValorTotalLiquido(valorHTLiquido);
                          setMargemLucro(
                            parseFloat(valorHTLiquido * (percentualLucro / 100)).toFixed(2),
                          );
                          setValorOrcamento(
                            parseFloat(valorHTLiquido * ((100 - percentualLucro) / 100)).toFixed(2),
                          );

                          let horasPreDev = parseFloat(
                            (
                              (valorHTLiquido * ((100 - percentualLucro) / 100)) /
                              valorMediaAna
                            ).toFixed(0),
                          );
                          setHorasPrevistaDev(horasPreDev);
                          setHorasGP(parseFloat((horasPreDev * (percentualGP / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPreDev - horasPreDev * (percentualGP / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>
                    <Label title="Valor Media Ana. *" className="col s12 m6 l2">
                      <Input
                        type="number"
                        name="valorMediaAna"
                        min="1"
                        required="true"
                        value={valorMediaAna}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setValorMediaAna(v);

                          let horasPreDev = parseFloat((valorOrcamento / v).toFixed(0));
                          setHorasPrevistaDev(horasPreDev);
                          setHorasGP(parseFloat((horasPreDev * (percentualGP / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPreDev - horasPreDev * (percentualGP / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>
                    <Label title="% Imposto" className="col s12 m6 l2">
                      <Input
                        type="number"
                        name="percentualImposto"
                        min="1"
                        required="true"
                        value={percentualImposto}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setPercentualImposto(v);
                          setValorHoraLiquido(valorHoraBruto - valorHoraBruto * (v / 100));
                          setValorImposto((valorTotalBruto * (v / 100)).toFixed(2));

                          let valorHTLiquido = valorTotalBruto - valorTotalBruto * (v / 100);
                          setValorTotalLiquido(valorHTLiquido);
                          setMargemLucro(
                            parseFloat(valorHTLiquido * (percentualLucro / 100)).toFixed(2),
                          );
                          setValorOrcamento(
                            parseFloat(valorHTLiquido * ((100 - percentualLucro) / 100)).toFixed(2),
                          );

                          let horasPreDev = parseFloat((valorHTLiquido / valorMediaAna).toFixed(0));
                          setHorasPrevistaDev(horasPreDev);
                          setHorasGP(parseFloat((horasPreDev * (percentualGP / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPreDev - horasPreDev * (percentualGP / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>
                    <Label title="% Lucro" className="col s12 m6 l2">
                      <Input
                        type="number"
                        name="percentualLucro"
                        min="1"
                        max="100"
                        required="true"
                        value={percentualLucro}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setPercentualLucro(v);
                          setMargemLucro(parseFloat(valorTotalLiquido * (v / 100)).toFixed(2));
                          setValorOrcamento(
                            parseFloat(valorTotalLiquido * ((100 - v) / 100)).toFixed(2),
                          );

                          let horasPreDev = parseFloat(
                            ((valorTotalLiquido * ((100 - v) / 100)) / valorMediaAna).toFixed(0),
                          );
                          setHorasPrevistaDev(horasPreDev);
                          setHorasGP(parseFloat((horasPreDev * (percentualGP / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPreDev - horasPreDev * (percentualGP / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>
                    <Label title="% Gestão Projeto *" className="col s12 m6 l2">
                      <Input
                        type="number"
                        name="percentualGP"
                        min="1"
                        required="true"
                        value={percentualGP}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setPercentualGP(v);

                          setHorasGP(parseFloat((horasPrevistaDev * (v / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPrevistaDev - horasPrevistaDev * (v / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>
                  </div>
                </div>
                <div className="col s12 m12 l4 no-padding lista-calculo">
                  <div className="row no-margin">
                    <Label title="Valor Hora Bruto *" className="col s12 m6 l12 text-h">
                      <Input
                        type="number"
                        name="valorHoraBruto"
                        required="true"
                        step="0.10"
                        value={valorHoraBruto}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setValorHoraBruto(v);
                          setValorTotalBruto(v * horaLevantamento);
                          setValorHoraLiquido(v - v * (percentualImposto / 100));
                          setValorTotalLiquido(
                            parseFloat(
                              ((v - v * (percentualImposto / 100)) * horaLevantamento).toFixed(2),
                            ),
                          );
                          setMargemLucro(
                            parseFloat(
                              (v - v * (percentualImposto / 100)) *
                                horaLevantamento *
                                (percentualLucro / 100),
                            ).toFixed(2),
                          );
                          setValorOrcamento(
                            parseFloat(
                              (v - v * (percentualImposto / 100)) *
                                horaLevantamento *
                                ((100 - percentualLucro) / 100),
                            ).toFixed(2),
                          );

                          let horasPreDev = parseFloat(
                            (
                              ((v - v * (percentualImposto / 100)) *
                                horaLevantamento *
                                ((100 - percentualLucro) / 100)) /
                              valorMediaAna
                            ).toFixed(0),
                          );
                          setHorasPrevistaDev(horasPreDev);
                          setHorasGP(parseFloat((horasPreDev * (percentualGP / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPreDev - horasPreDev * (percentualGP / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Valor Hora Liquido *" className="col s12 m6 l12 text-h">
                      <Input
                        type="number"
                        name="valorHoraLiquido"
                        required="true"
                        step="0.10"
                        value={valorHoraLiquido}
                        onChange={e => {
                          const v = e.currentTarget.value || 0;
                          setValorHoraLiquido(v);
                          setValorTotalLiquido(parseFloat((v * horaLevantamento).toFixed(2)));
                          setMargemLucro(
                            parseFloat(v * horaLevantamento * (percentualLucro / 100)).toFixed(2),
                          );
                          setValorOrcamento(
                            parseFloat(
                              v * horaLevantamento * ((100 - percentualLucro) / 100),
                            ).toFixed(2),
                          );

                          let horasPreDev = parseFloat(
                            (
                              (v * horaLevantamento * ((100 - percentualLucro) / 100)) /
                              valorMediaAna
                            ).toFixed(0),
                          );
                          setHorasPrevistaDev(horasPreDev);
                          setHorasGP(parseFloat((horasPreDev * (percentualGP / 100)).toFixed(0)));
                          setHorasDev(
                            parseFloat(
                              (horasPreDev - horasPreDev * (percentualGP / 100)).toFixed(0),
                            ),
                          );
                        }}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Receita Bruta *" className="col s12 m6 l12 text-h">
                      <Input
                        type="number"
                        name="valorTotalBruto"
                        step="0.10"
                        required="true"
                        value={valorTotalBruto}
                        disabled="true"
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Imposto *" className="col s12 m6 l12 text-h">
                      <Input
                        type="number"
                        name="valorImposto"
                        step="0.10"
                        required="true"
                        disabled="true"
                        value={valorImposto}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Receita Liquida *" className="col s12 m6 l12 text-h">
                      <Input
                        type="number"
                        name="valorTotalLiquido"
                        step="0.10"
                        required="true"
                        value={valorTotalLiquido}
                        disabled="true"
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Margem Lucro *" className="col s12 m6 l12 text-h">
                      <Input
                        type="number"
                        name="margemLucro"
                        step="0.10"
                        required="true"
                        value={margemLucro}
                        disabled="true"
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Valor Orçamento *" className="col s12 m6 l12 text-h">
                      <Input
                        type="number"
                        name="valorOrcamento"
                        step="0.10"
                        required="true"
                        value={valorOrcamento}
                        disabled="true"
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Horas Total Prev *" className="col s12 m6 l12 text-h">
                      <Input
                        type="number"
                        name="horasPrevistaDev"
                        min="1"
                        required="true"
                        value={horasPrevistaDev}
                        disabled="true"
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Horas Gestão Projeto *" className="col s12 m6 l12 text-h">
                      <Input
                        type="number"
                        name="horasGP"
                        min="1"
                        required="true"
                        value={horasGP}
                        disabled="true"
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <Label title="Horas Desenv *" className="col s12 m6 l12 text-h">
                      <Input
                        type="number"
                        name="horasDev"
                        min="1"
                        required="true"
                        value={horasDev}
                        disabled="true"
                      />
                    </Label>
                  </div>
                </div>
              </div>
            </div>
            <div className={abaAtiva == 2 ? 'item-modal ativo' : 'item-modal'}>
              <div className="row no-margin">
                <div className="col s6 m6 l8 no-padding">
                  <div className="row no-margin">
                    <Label title="Horas Total Prev *" className="col s12 m6 l2">
                      <Input
                        type="number"
                        name="horasPrevistaDev"
                        min="1"
                        required="true"
                        value={horasPrevistaDev}
                        disabled="true"
                      />
                    </Label>
                    <Label title="Horas para Gestão *" className="col s12 m6 l2">
                      <Input
                        type="number"
                        name="horasGP"
                        min="1"
                        required="true"
                        value={horasGP}
                        disabled="true"
                      />
                    </Label>
                    <Label title="Outras Atividades *" className="col s12 m6 l2">
                      <Input
                        type="number"
                        name="horasDev"
                        min="1"
                        required="true"
                        value={horasDev}
                        disabled="true"
                      />
                    </Label>
                  </div>
                </div>
                <div className="col s6 m6 l4 no-padding">
                  <div className="row no-margin">
                    <Label title="Horas em Atividades *" className="col s12 m6 l4">
                      <Input
                        type="number"
                        name="horaTotal"
                        required="true"
                        disabled="true"
                        min="1"
                        value={horaTotal}
                      />
                    </Label>
                    <Label title="Horas Liberadas *" className="col s12 m6 l4">
                      <Input
                        type="number"
                        name="horaSaldo"
                        required="true"
                        disabled="true"
                        min="1"
                        value={horaSaldo}
                      />
                    </Label>
                    <Label title="Horas Usadas *" className="col s12 m6 l4">
                      <Input
                        type="number"
                        name="horaUsada"
                        required="true"
                        disabled="true"
                        min="1"
                        value={horaUsada}
                      />
                    </Label>
                  </div>
                </div>
              </div>
              <div className="row no-margin">
                <div className="col s12 m12 l12">
                  <AtividadesList
                    setter={setAtividades}
                    defaultData={mountedData?.atividades || []}
                    setterSoma={setHoraTotal}
                    setterSomaLib={setHoraSaldo}
                    gerarProjeto={true}
                  />
                </div>
              </div>
            </div>
            <div className={abaAtiva == 3 ? 'item-modal ativo' : 'item-modal'}>
              <div className="row no-margin">
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <Label title="Solicitante Cliente *" className="col s12 m4 l6">
                      <Select
                        required="true"
                        isString
                        list={{ list: solicitantes, value: 'id', label: 'nome' }}
                        name="idClienteSolicitante"
                        firstOption
                        defaultValue={mountedData?.idClienteSolicitante}
                      />
                    </Label>
                    <Label title="Envia Email *" className="col s12 m6 l3">
                      <Select
                        required="true"
                        isString
                        list={{
                          list: [
                            { id: 'S', titulo: 'Sim' },
                            { id: 'N', titulo: 'Não' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name="emailRespCliente"
                        defaultValue={mountedData?.enviaEmailSolicitante}
                      />
                    </Label>
                    <Label title="Ativo *" className="col s12 m6 l3">
                      <Select
                        required="true"
                        isString
                        list={{
                          list: [
                            { id: 'true', titulo: 'Sim' },
                            { id: 'false', titulo: 'Não' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        name="ativo"
                        defaultValue={mountedData?.ativo?.toString()}
                        onChange={e => {
                          const v = e.currentTarget.value || 'true';
                          setAtivo(v);
                        }}
                      />
                    </Label>
                  </div>
                  <div className="row no-margin">
                    <div className="col s12 m12 l12">
                      <RecursosList
                        setter={setRecursos}
                        defaultData={
                          typeof mountedData?.recurso == 'object'
                            ? mountedData?.recurso || []
                            : JSON.parse(mountedData?.recurso)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col s6 m6 l6 no-padding">
                  <div className="row no-margin">
                    <div className="col s12 m12 l12">
                      <StatusDataList
                        setter={setStatusDatas}
                        defaultData={mountedData?.etapas || []}
                        etapasList={etapas}
                        dataInicio={dataInicioProjeto}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={abaAtiva == 4 ? 'item-modal ativo' : 'item-modal'}>
              <div className="row no-margin">
                <div className="col s12 m12 l12">
                  <AcessosList setter={setAcessos} defaultData={mountedData?.acessos || []} />
                </div>
              </div>
            </div>
          </div>
        )}
      </Materialize>
      <div className="footer">
        <Label title="Etapa *" className="no-margin" row={true}>
          <Select
            required="true"
            isString
            list={{ list: etapas, value: 'id', label: 'titulo' }}
            name="idEtapaFluxo"
            defaultValue={idEtapa}
            onChange={e => {
              const v = e.currentTarget.value || 0;
              setIdEtapa(parseInt(v));

              const item = etapas.find(data => data?.id === parseInt(v));
              setGerarProjeto(item?.final == 'S' ? true : false);
            }}
          />
        </Label>
        {/* <PrioridadeListColor
          name="idPrioridade"
          setter={setPrioridade}
          defaultData={mountedData?.prioridade}
        /> */}
      </div>
    </Container>
  );
}

export default CreateEditContent;
